import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoading: false,
  message: null,
};

export const formEventSlice = createSlice({
  name: "formEvent",
  initialState,
  reducers: {
    setIsLoading(state) {
      state.isLoading = true;
      state.message = null;
    },
    setErrorMessage(state, { payload }) {
      state.isLoading = false;
      state.message = {
        type: "error",
        text: payload,
      };
    },
    setSuccessMessage(state, { payload }) {
      state.isLoading = false;
      state.message = {
        type: "success",
        text: payload,
      };
    },
    clearFormEvent(state) {
      state.isLoading = false;
      state.message = null;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setIsLoading,
  setErrorMessage,
  setSuccessMessage,
  clearFormEvent,
} = formEventSlice.actions;
